const fxb = require('flatbuffers/js/flexbuffers')

module.exports = {
  bmap: (bObject, bArrayName, func) => {
    const result = []
    const length = bObject[bArrayName + 'Length']()

    for (let i = 0; i < length; i++) {
      result.push(bObject[bArrayName](i))
    }

    return result.map(func)
  },

  createEnumDecoder: (FbLib) => {
    return function (name, value) {
      return FbLib[name][value]
    }
  },

  decodeFlexBufferObject: (bParentObject, entityName) => {
    const isExists = bParentObject[`${entityName}Length`]

    if (!isExists) {
      return null
    }

    return fxb.toObject(new Uint8Array(bParentObject[`${entityName}Array`]()).buffer)
  },
}